import styled, { css } from 'styled-components';
import { ScQuestionAnswerItem } from '@/components/QuestionAnswerItem/styled';
import { device, hexToRGB, typography } from '@/styles/helpers';

interface IScFaqContainerProps {
  $isOpen?: boolean;
}

export const ScFaqContainer = styled.div<IScFaqContainerProps>`
  width: 100%;
  margin-top: 24px;

  ${ScQuestionAnswerItem} {
    background-color: transparent;
    border-bottom: ${({ theme }) => `1px solid ${hexToRGB(theme.white, 0.2)}`};
    border-radius: 0;
    padding: 12px 16px;

    &:first-child {
      border-top: ${({ theme }) => `1px solid ${hexToRGB(theme.white, 0.2)}`};
    }

    > .question {
      padding: 0;
    }
    .question:hover > .open-close-btn::before,
    .question:hover > .open-close-btn::after {
      background-color: ${({ theme }) => theme.white};
    }

    &[data-selected="true"] {
      .open-close-btn::before,
      .open-close-btn::after {
        background-color: ${({ theme }) => theme.white};
      }

      .answer {
        margin-top: 8px;
      }
    }

    > .answer-box > .answer {
      padding: 0;
      transition: margin-top 0.4s ease;
      > * {
        ${typography.body1regular};
        color: ${({ theme }) => theme.color2};
        margin: 0;
        padding: 0;
      }
    }
  }
`;

export const ScDescriptionContainer = styled.div<{ isExpanded: boolean }>`
  position: relative;
  max-height: 280px;
  height: 100%;
  overflow-y: hidden;
  padding-bottom: 32px;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      max-height: initial;
      padding-bottom: 64px;
    `}
`;

export const ScDescriptionAction = styled.div<{ isExpanded: boolean }>`
  position: absolute;
  bottom: 0px;

  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 80px;
  width: 100%;

  ${({ isExpanded, theme }) =>
    !isExpanded &&
    css`
      background: ${theme.blackGradient};
    `}
`;

export const ScDescriptionText = styled.div`
  * > * {
    color: ${({ theme }) => theme.white};
  }

  .img-wrapper {
    border-radius: 8px;
    overflow: hidden;
    display: inline-block;
    margin: 16px 0;
    max-width: 865px;
    width: 100%;
  }

  img {
    height: 267px;
    width: 100%;
    border-radius: 8px;
    @media (${device.mobile}) {
      height: 106px;
    }
  }

  hr {
    opacity: 50%;
  }

  h1 {
    margin: 0 0 8px;
    ${typography.headline2}
    @media (${device.mobile}) {
      ${typography.headline2mobile}
    }
  }

  blockquote {
    margin: 24px 8px;
    background-color: ${({ theme }) => theme.color1};
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.color2};
    & cite {
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      font-style: normal;
    }
  }

  h2 {
    margin: 0.83em 0 8px;
  }
  h3 {
    margin: 1.17em 0 8px;
  }
  h4 {
    margin: 1.33em 0 8px;
  }
  h5 {
    margin: 1.67em 0 8px;
  }
  h6 {
    margin: 2.33em 0 8px;
  }
  p {
    margin: 1em 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    & + p {
      margin-top: 0;
    }
  }

  p,
  td,
  th {
    color: ${({ theme }) => theme.white};
  }

  ul {
    list-style-type: disc;
    & + div table {
      margin-top: 16px;
    }
  }

  ul,
  ol {
    margin: 0 32px;
    li {
      margin: 0px !important;
      p {
        margin: 0;
        padding: 0;
      }
    }
  }
`;

export const ScSeoTopSpacing = styled.div`
  margin-top: 32px;
`;
